<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Reporting</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <form>
    <div class="row">
      <div class="col-auto d-flex align-items-center">
        <label class="form-label mb-0">Report Type</label>
      </div>
      <div class="col d-flex align-items-center">
        <select class="form-select" [(ngModel)]="selectedReport" name="reportType">
          <option value="">Select a report...</option>
          @for (type of reportTypes; track type) {
            <option [value]="type.id">
              {{type.name}}
            </option>
          }
        </select>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="showReport()">Confirm</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
